<div class="collection-filter">
  @for (item of collections; track item.code) {
    <div class="form-check form-switch">
      <input
        type="checkbox"
        class="form-check-input"
        [id]="'col-' + item.code"
        [checked]="item.enabled"
        (change)="toggle(item)"
      />
      <label class="form-check-label" [for]="'col-' + item.code">
        {{ item.labelKey | translate }}
      </label>
    </div>
  }
</div>
